module.exports = __webpack_public_path__ + "img/10c2141.jpg";